<template>
  <div class="comp-qf-ellipsis" ref="container">
    <jw-tooltip v-if="isOverflow" :content="content" placement="top">
      <div class="ellipsis-content">
        <slot>{{ content }}</slot>
      </div>
    </jw-tooltip>
    <div v-else class="ellipsis-content">
      <slot>{{ content }}</slot>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick, watch } from 'vue';

const props = defineProps({
  content: {
    type: String,
    required: true
  }
});

const container = ref(null);
const isOverflow = ref(false);
let resizeObserver = null;

const checkOverflow = () => {
  const element = container.value?.querySelector('.ellipsis-content');
  if (element) {
    isOverflow.value = element.scrollWidth > element.clientWidth;
  }
};

const stopWatch = watch(
  () => props.content,
  () => {
    nextTick(checkOverflow);
  }
);

onMounted(() => {
  checkOverflow();
  // 使用 ResizeObserver 监听容器大小变化
  resizeObserver = new ResizeObserver(() => {
    checkOverflow();
  });
  if (container.value) {
    resizeObserver.observe(container.value);
  }
});

onBeforeUnmount(() => {
  // 清理 ResizeObserver
  if (resizeObserver) {
    resizeObserver.disconnect();
    resizeObserver = null;
  }
  stopWatch();
  container.value = null;
});
</script>
<style scoped lang="less">
@import './qf-ellipsis.less';

.comp-qf-ellipsis {
  width: 100%;

  .ellipsis-content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow-wrap: break-word;
  }
}
</style>
